import React from "react";
import logoSvg from "../images/logos/BestJobsOnline_logo.svg";

const { GATSBY_COUNTRY, GATSBY_DOMAIN } = process.env;

export default function LogoSVG() {
  return (
    <img
      src={logoSvg}
      width={160}
      alt={`https://${GATSBY_COUNTRY}.${GATSBY_DOMAIN}`}
    />
  );
}
